/**
 * Event constants for the application's event bus
 * Use these constants when dispatching or listening for events to ensure consistency
 */
export const MASK = '*********';
export const masks = [
  'password',
  'new_password'
];

// Authentication related events
export const AUTH_EVENTS = {
  DEADMAN_LOGIN: "deadman_login",
  DEADMAN_LOGIN_ERROR: "deadman_login_error",
};

// Navigation related events
export const NAVIGATION_EVENTS = {
  ROUTE_CHANGE: "route_change",
};

// User action events
export const USER_EVENTS = {
  USER_LOGOUT: "user_logout",
  USER_LOGIN: "user_login",
  USER_LOGIN_ERROR: "user_login_error",
  PROFILE_UPDATE: "profile_update",
  
  USER_GENERATE_CREDENTIALS: "user_generate_credentials",
  USER_GENERATE_CREDENTIALS_ERROR: "user_generate_credentials_error",
  
  // signup differs from creds generation
  USER_SIGNUP: "user_signup_success",
  USER_SIGNUP_ERROR: "user_signup_error",
};

// API related events
export const API_EVENTS = {
  API_ERROR: "api_error",
  API_SUCCESS: "api_success",
};

export const VENUE_DETAILS_ERROR_STRING = "Error loading venue details. Please try again later.";
export const TOTAL_LOAD_FAILURE_ERROR_STRING = "Failed to fetch data from both Cloud Storage and local fallback";
export const GCS_ERROR_STRING = "There was a problem loading venue details from cloud storage, falling back to local data.";
export const ERROR_EVENTS = {
  FAILURE_TO_LOAD_ERROR: "gcs_and_fallback_load_failure",
  GCS_FAILURE_ERROR: "gcs_failure_fallback_to_local_data",
};

// user selection (cancel reason) is submitted as 'event_details'
export const SELFCARE_EVENTS = {
  CANCEL_REASON_SELECTION: "cancel_reason_selection",
  CANCEL_SUBREASON_SELECTION: "cancel_subreason_selection",
  SAVE_OFFER_CLAIMED: "save_offer_claimed",
  BTN_CLICK: "button_click",
};

// Add more event categories as needed
